import { Result } from 'antd';

import { ru } from '@/i18n/ru';

interface Props {
  title: string;
  stage: number;
}

/** Stand-in for a section delivered in a later plan stage. */
export function PlaceholderPage({ title, stage }: Props) {
  return <Result status="info" title={title} subTitle={ru.placeholder.soon(stage)} />;
}

export function NotFoundPage({ onHome }: { onHome: () => void }) {
  return (
    <Result
      status="404"
      title={ru.errors.notFound}
      extra={
        <a
          href="/"
          onClick={(event) => {
            event.preventDefault();
            onHome();
          }}
        >
          {ru.errors.toHome}
        </a>
      }
    />
  );
}
